module.exports = __webpack_public_path__ + "img/tintuc13.61125801.png";